import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, BookOpen, FlaskConical } from 'lucide-react';
export function Transformacion() {
  return <section className="py-24 px-4 bg-[#F0F2EB]" data-id="element-433">
      <div className="max-w-5xl mx-auto" data-id="element-434">
        <div className="text-center mb-16" data-id="element-435">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-green mb-4" data-id="element-436">
            ¿Qué cambia cuando tenés el sistema?
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-437">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-438">
            <div className="w-12 h-12 bg-green/10 rounded-xl flex items-center justify-center text-green mb-6" data-id="element-439">
              <Calendar size={24} data-id="element-440" />
            </div>
            <h3 className="text-xl font-bold text-green mb-4 uppercase tracking-wide" data-id="element-441">
              Planificar
            </h3>
            <div className="space-y-4 text-sm" data-id="element-442">
              <p className="text-slate" data-id="element-443">
                <span className="font-bold text-terracota" data-id="element-444">Antes:</span> cada
                semana buscás, adaptás, armás.
              </p>
              <p className="text-ink" data-id="element-445">
                <span className="font-bold text-green" data-id="element-446">Con el Mega Pack:</span>{' '}
                abrís, elegís y entrás al aula.
              </p>
              <p className="text-slate pt-4 border-t border-cream-dark" data-id="element-447">
                Los contenidos están organizados en secuencia lógica, con
                actividades y evaluaciones alineadas a cada unidad. No empezás
                de cero nunca más.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-448">
            <div className="w-12 h-12 bg-terracota/10 rounded-xl flex items-center justify-center text-terracota mb-6" data-id="element-449">
              <BookOpen size={24} data-id="element-450" />
            </div>
            <h3 className="text-xl font-bold text-green mb-4 uppercase tracking-wide" data-id="element-451">
              Enseñar
            </h3>
            <div className="space-y-4 text-sm" data-id="element-452">
              <p className="text-slate" data-id="element-453">
                <span className="font-bold text-terracota" data-id="element-454">Antes:</span>{' '}
                encontrás teoría que no tiene contexto latinoamericano.
              </p>
              <p className="text-ink" data-id="element-455">
                <span className="font-bold text-green" data-id="element-456">Con el Mega Pack:</span>{' '}
                explicás procesos técnicas con ejemplos reales de tu región,
                formulaciones concretas y parámetros medibles en el taller.
              </p>
              <p className="text-slate pt-4 border-t border-cream-dark" data-id="element-457">
                Tus alumnos entienden porque el material habla de productos que
                conocen.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-cream-dark" data-id="element-458">
            <div className="w-12 h-12 bg-petrol/10 rounded-xl flex items-center justify-center text-petrol mb-6" data-id="element-459">
              <FlaskConical size={24} data-id="element-460" />
            </div>
            <h3 className="text-xl font-bold text-green mb-4 uppercase tracking-wide" data-id="element-461">
              Aplicar
            </h3>
            <div className="space-y-4 text-sm" data-id="element-462">
              <p className="text-slate" data-id="element-463">
                <span className="font-bold text-terracota" data-id="element-464">Antes:</span> la
                teoría y la práctica de taller no se conectan.
              </p>
              <p className="text-ink" data-id="element-465">
                <span className="font-bold text-green" data-id="element-466">Con el Mega Pack:</span>{' '}
                cada contenido tiene su actividad práctica, su ficha técnica y
                su proyecto productivo.
              </p>
              <p className="text-slate pt-4 border-t border-cream-dark" data-id="element-467">
                El alumno ve la cadena completa: de la materia prima al producto
                terminado, envasado y calculado.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="text-center" data-id="element-468">
          <p className="text-2xl font-serif italic text-ink" data-id="element-469">
            "El mejor docente no es el que más busca.{' '}
            <span className="text-terracota font-bold not-italic" data-id="element-470">
              Es el que mejor enseña.
            </span>
            "
          </p>
        </div>
      </div>
    </section>;
}